"use strict";

var agendorAPI = require("app/util/api/agendor-api");

module.exports.post = function create(team, success, error) {
  var responseHandler = agendorAPI.getResponseHandler(success, error);
  agendorAPI.post("/reports/monthly_summary", team, responseHandler, "2.1");
};



// WEBPACK FOOTER //
// ./app/util/api/summary.js